import axios from "axios"
import { getUrl } from "../../utility/helpers/url"
import { store } from "../../redux/storeConfig/store"

/**
 * @class ValidationLocationService
 */
class ValidationLocationService {
  constructor(config) {
    this.config = config
  }

  /**
   * Get the appropriate URL based on user role
   *
   * @param {string} jobSiteId
   * @param {string} companyId
   * @returns {string}
   */
  getLocationUrl(jobSiteId, companyId) {
    const state = store.getState()
    const userData = state.auth.userData
    const role = userData?.role

    return role === "admin"
      ? `/admin/company/${companyId}/job-site/${jobSiteId}/location`
      : `/admin/job-site/${jobSiteId}/location`
  }

  /**
   * Get list of validation locations
   *
   * @param {object} params
   * @returns {Promise<boolean|T>}
   */
  async listLocations({ companyId, jobSiteId }) {
    try {
      const response = await axios.get(
        getUrl(this.getLocationUrl(jobSiteId, companyId))
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  /**
   * Create a new validation location
   *
   * @param {object} data
   * @param {object} params
   * @returns {Promise<boolean|T>}
   */
  async createLocation(data, { companyId, jobSiteId }) {
    try {
      const response = await axios.post(
        getUrl(this.getLocationUrl(jobSiteId, companyId)),
        data
      )
      return response.data
    } catch (error) {
      console.error("Failed to create validation location:", error)
      throw new Error(`Failed to create validation location: ${error.message}`)
    }
  }

  /**
   * Update a validation location
   *
   * @param {number} locationId
   * @param {object} data
   * @param {object} params
   * @returns {Promise<boolean|T>}
   */
  async updateLocation(locationId, data, { companyId, jobSiteId }) {
    try {
      const response = await axios.put(
        getUrl(`${this.getLocationUrl(jobSiteId, companyId)}/${locationId}`),
        data
      )
      return response.data
    } catch (error) {
      console.error("Failed to update validation location:", error)
      throw new Error(`Failed to update validation location: ${error.message}`)
    }
  }

  /**
   * Delete a validation location
   *
   * @param {number} locationId
   * @param {object} params
   * @returns {Promise<boolean|T>}
   */
  async deleteLocation(locationId, { companyId, jobSiteId }) {
    try {
      const response = await axios.delete(
        getUrl(`${this.getLocationUrl(jobSiteId, companyId)}/${locationId}`)
      )
      return response.data
    } catch (error) {
      console.error("Failed to delete validation location:", error)
      throw new Error(`Failed to delete validation location: ${error.message}`)
    }
  }
}

export default ValidationLocationService
